module.exports = __webpack_public_path__ + "static/media/Gorillas.79058643.png";